import Reveal from "@/components/feature/Reveal";
import { featuredStacks } from "@/mocks/homeData";

export default function FeaturedStacks() {
  return (
    <section id="proof" className="w-full px-4 md:px-10 py-16 md:py-24 bg-background-100">
      <Reveal className="max-w-2xl">
        <p className="font-label text-xs md:text-sm tracking-[0.24em] text-primary-600">铁板石锤速览</p>
        <h2 className="mt-4 font-heading font-black text-2xl md:text-4xl text-foreground-950">
          这几件事，材料已经摆到桌面上了
        </h2>
        <p className="mt-4 font-body text-sm md:text-base leading-7 text-foreground-600">
          按事件编号排列，每条都标出当前状态与材料构成。状态只是整理进度，结论留给你自己看。
        </p>
      </Reveal>

      <div className="mt-10 md:mt-14 flex flex-col gap-6 md:gap-9">
        {featuredStacks.map((stack, index) => {
          const reversed = index % 2 === 1;
          return (
            <Reveal key={stack.id} as="article" delay={index * 60}>
              <div className="grid grid-cols-1 lg:grid-cols-12 rounded-lg border border-background-200 bg-background-50 overflow-hidden">
                <div className={`lg:col-span-5 ${reversed ? "lg:order-2" : ""} p-4 md:p-5`}>
                  <div className="w-full h-56 md:h-full md:min-h-[280px] rounded-md overflow-hidden bg-background-200">
                    <img
                      src={stack.image}
                      alt={`${stack.title} 相关的证据材料展示`}
                      title={`${stack.title} 黑料爆料实锤证据`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                </div>

                <div className={`lg:col-span-7 ${reversed ? "lg:order-1" : ""} p-5 md:p-8 flex flex-col`}>
                  <div className="flex flex-wrap items-center gap-3">
                    <span className="font-label text-xs text-foreground-500 tracking-wide">{stack.seq}</span>
                    <span className="inline-flex items-center rounded-full bg-secondary-100 px-3 py-1 font-label text-xs text-secondary-900">
                      {stack.tag}
                    </span>
                    <span className="font-label text-xs text-foreground-500">更新于 {stack.updatedAt}</span>
                  </div>

                  <h3 className="mt-4 font-heading font-bold text-xl md:text-2xl leading-snug text-foreground-950">
                    {stack.title}
                  </h3>
                  <p className="mt-4 font-body text-sm md:text-base leading-7 text-foreground-600 flex-1">
                    {stack.summary}
                  </p>

                  <div className="mt-6 pt-5 border-t border-background-200 flex flex-wrap items-center gap-x-8 gap-y-3">
                    {stack.stats.map((stat) => (
                      <span key={stat.label} className="flex flex-col">
                        <span className="font-label text-xs text-foreground-500">{stat.label}</span>
                        <span className="mt-0.5 font-heading font-black text-base text-foreground-950">
                          {stat.value}
                        </span>
                      </span>
                    ))}
                    <a
                      href="#library"
                      className="ml-auto inline-flex items-center gap-2 rounded-md border border-background-300 px-4 py-2.5 font-label text-sm text-foreground-800 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
                    >
                      <i className="ri-links-line text-base" aria-hidden="true"></i>
                      对照材料
                    </a>
                  </div>
                </div>
              </div>
            </Reveal>
          );
        })}
      </div>
    </section>
  );
}